import React from 'react';
import type { CardProps } from './types';

/**
 * Card component - podobny do TailAdmin
 * 
 * Nowoczesna karta z nagłówkiem, treścią i opcjonalnym footerem.
 * Stylizowana z subtelnymi cieniami i zaokrąglonymi rogami.
 */
export const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  children,
  headerActions,
  className = '',
  fullHeight = false,
  footer,
  noPadding = false
}) => {
  return (
    <div
      className={`bg-white border border-gray-200 rounded-lg shadow-sm ${fullHeight ? 'h-full' : ''} flex flex-col ${className}`}
      style={{
        backgroundColor: 'var(--card, #ffffff)',
        borderColor: 'var(--border, #e5e7eb)',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)'
      }}
    >
      {/* Header */}
      {(title || subtitle || headerActions) && (
        <div
          className="px-4 py-3 border-b border-gray-200 flex items-center justify-between"
          style={{
            borderBottomColor: 'var(--border, #e5e7eb)',
            backgroundColor: 'var(--bg, #f9fafb)'
          }}
        >
          <div className="flex flex-col min-w-0 flex-1">
            {title && (
              <h3
                className="text-sm font-semibold text-gray-900 m-0"
                style={{
                  fontSize: '14px',
                  fontWeight: 600,
                  color: 'var(--text, #111827)',
                  lineHeight: '1.5'
                }}
              >
                {title}
              </h3>
            )}
            {subtitle && (
              <p
                className="text-xs text-gray-500 mt-0.5 m-0"
                style={{
                  fontSize: '12px',
                  color: 'var(--muted, #6b7280)',
                  marginTop: '2px',
                  lineHeight: '1.5'
                }}
              >
                {subtitle}
              </p>
            )}
          </div>
          {headerActions && (
            <div className="flex items-center gap-2 ml-4 flex-shrink-0">
              {headerActions}
            </div>
          )}
        </div>
      )}

      {/* Content */}
      <div 
        className={`flex-1 min-h-0 ${noPadding ? '' : 'px-4 py-4'}`} 
        style={noPadding ? {} : { padding: '16px' }}
      >
        {children}
      </div>

      {/* Footer */}
      {footer && (
        <div
          className="px-4 py-3 border-t border-gray-200"
          style={{
            borderTopColor: 'var(--border, #e5e7eb)',
            backgroundColor: 'var(--bg, #f9fafb)'
          }}
        >
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card;

